import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FrontRoutingModule } from './front-routing.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
//import { AgmCoreModule } from '@agm/core';
import { environment } from '../../environments/environment';
import { GoogleMapsModule } from '@angular/google-maps';

@NgModule({
  declarations: [
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    FrontRoutingModule,
    GoogleMapsModule
    /*AgmCoreModule.forRoot({
      apiKey: environment.GOOGLE_MAP_KEY,
      libraries: ['places', 'drawing', 'geometry']
  }),*/
  ]
})
export class FrontModule { }
